import axios from 'axios';

//const URL = `${window.location.origin}/api`;
const URL = 'https://werlins.de/php-rest-api/api';
//const URL = 'http://localhost:8082';

export const getIdeen = async () => {
  try {
    return await axios.get(`${URL}/get.php`);
//	return await axios.get(`${URL}/ideen`);
  } catch (error) {
    console.log('Error while calling get Ideen API', error);
  }
};

export const getIdee = async (id) => {
  try {
	return await axios.get(`${URL}/get.php?id=${id}`);
//    return await axios.get(`${URL}/ideen/editIdee/${id}`);
  } catch (error) {
    console.log('Error while calling get idee API', error);
  }
};

export const editIdee = async (ideeDetails) => {
  try {
	return await axios.put(`${URL}/put.php`, ideeDetails);
//  return await axios.put(`${URL}/ideen/editIdee/${ideeDetails.id}`, ideeDetails);
  } catch (error) {
    console.log('Error while calling edit idee API', error);
  }
};

export const addIdee = async (kurzfassung, idee, von, datum) => {
  try {
    const ideeDetails = {
      kurzfassung: kurzfassung,
      idee: idee,
      von: von,
      datum: datum,
    };
	return await axios.post(`${URL}/post.php`, ideeDetails);
//   return await axios.post(`${URL}/ideen/addIdee`, ideeDetails);
  } catch (error) {
    console.log('Error while calling add idee API', error);
  }
};

export const deleteIdee = async (id) => {
  try {
    const idNr = {
	  id  : id,
    };	  
    return await axios.delete(`${URL}/delete.php?id=${id}`);	  
// return await axios.delete(`${URL}/ideen/${id}`);
  } catch (error) {
    console.log('Error while calling delete idee API', error);
  }
};
